<template>
  <RadioGroup v-model="data.value" @change="bindChange">
    <RadioItem
      :class="[
        data.show_type ? 'radio-item-' + data.show_type : '',
        data.options.length == 2 ? 'radio-item-two' : ''
      ]"
      v-for="(item, index) in data.options"
      :key="index"
      :value="item.key"
      :theme="theme"
    >
      <div style="height: 100%">
        <div
          class="radio-text"
          :style="{
            background:
              data.value == item.key ? theme.checkColor : theme.notCheckColor
          }"
          v-if="item.value && !item.que_answer_icon"
          v-html="item.value"
        ></div>
        <div
          class="radio-image"
          :class="{ 'radio-image-active': data.value == item.key }"
          v-if="item.que_answer_icon"
        >
          <img style="width: 100%" :src="item.que_answer_icon" alt="" />
          <div
            class="radio-image-text"
            v-if="item.value"
            v-html="item.value"
          ></div>
        </div>
        <div
          @click.stop
          v-if="item.que_answer_attr && data.value == item.key"
          class="raido-input"
        >
          <van-field
            v-model="item.inputValue"
            rows="3"
            type="textarea"
            placeholder="请输入(选填)"
          />
        </div>
      </div>
    </RadioItem>
  </RadioGroup>
</template>
<script>
import RadioItem from './raido/radio.vue'
import RadioGroup from './raido/radio-group.vue'
export default {
  components: {
    RadioGroup,
    RadioItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-item-2 {
  width: 138px;
  .radio-text {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100%;
  }
}

.radio-item-two {
  width: 104px;
}

.radio-text {
  text-align: center;
  min-height: 52px;
  padding: 16px 4px;
  box-sizing: border-box;
  background: #f5f6fa;
  border-radius: 26px;
}

.radio-item-two {
  .radio-text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 104px;
    border-radius: 50%;
  }
}

.raido-input {
  margin-top: 10px;
  width: 100%;
  border: 1px solid #eee;
  box-sizing: border-box;
}

.radio-image {
  opacity: 0.3;

  .radio-image-text {
    margin-top: 18px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #373d52;
    line-height: 21px;
    text-align: center;
  }
}

.radio-image-active {
  opacity: 1;
}
</style>
